var firebaseConfig = {
    apiKey: "AIzaSyB-LORc0Z1sdk6f1BV1UdYXzgyNLWTpZBk",
    authDomain: "dri-cub.firebaseapp.com",
    projectId: "dri-cub",
    storageBucket: "dri-cub.appspot.com",
    messagingSenderId: "602896431030",
    appId: "1:602896431030:web:f752efcc8dedf342aeb317"
  };

  export default firebaseConfig;